export const MIRROR_TAG_SIZE = Object.freeze({ inches: [3.5, 9.5], pixels: [1400, 3800] });

// Percentages are shared by the responsive preview and the 1400 × 3800 export.
export const mirrorTagLayout = Object.freeze({
  opening: Object.freeze({ centerX: .5, centerY: .085, radius: .15, armHalfHeightRatio: .29 }),
  logo: Object.freeze({ x: .22, yWithVehicle: .205, yWithoutVehicle: .235, width: .56, height: .072 }),
  vehicle: Object.freeze({ yearY: .294, modelY: .319, maxWidth: .78 }),
  qr: Object.freeze({ x: .11, yWithVehicle: .405, yWithoutVehicle: .365, size: .78 }),
  cta: Object.freeze({ dividerY: .775, scanY: .835, siteY: .872 }),
  spine: Object.freeze({ top: .19, height: .57 })
});

export function getMirrorHangerGeometry(width, height) {
  const { centerX, centerY, radius, armHalfHeightRatio } = mirrorTagLayout.opening;
  const center = { x: width * centerX, y: height * centerY };
  const radiusPx = width * radius;
  const halfHeight = radiusPx * armHalfHeightRatio;
  const intersectionX = center.x - Math.sqrt(radiusPx ** 2 - halfHeight ** 2);
  return { center, radius: radiusPx, halfHeight, intersectionX, topY: center.y - halfHeight, bottomY: center.y + halfHeight };
}

export function getMirrorHangerSvgPath(width = 1000, height = 2714.2857) {
  const geometry = getMirrorHangerGeometry(width, height);
  return `M 0 ${geometry.topY} L ${geometry.intersectionX} ${geometry.topY} A ${geometry.radius} ${geometry.radius} 0 1 1 ${geometry.intersectionX} ${geometry.bottomY} L 0 ${geometry.bottomY} Z`;
}

export function traceMirrorHangerPath(context, width, height) {
  const geometry = getMirrorHangerGeometry(width, height);
  const angle = Math.asin(geometry.halfHeight / geometry.radius);
  context.beginPath(); context.moveTo(0, geometry.topY); context.lineTo(geometry.intersectionX, geometry.topY);
  context.arc(geometry.center.x, geometry.center.y, geometry.radius, -Math.PI + angle, Math.PI - angle, false);
  context.lineTo(0, geometry.bottomY); context.closePath();
}
